import { Component, Input, EventEmitter, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-happy-birthday',
  templateUrl: './happy-birthday.component.html',
  styleUrls: ['./happy-birthday.component.scss']
})
export class HappyBirthdayComponent {
  @Input() username: string;
  @Input() title: string;
  @Input() message: string;
  @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();



  constructor() {
  }

  public closeCard () {
      this.close.emit(true);
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/theme/components/happy-birthday/happy-birthday.component.ts